import { Dictionary } from 'typescript-collections';
import { WagoApiClient } from '@shared/service/wago-api.client';
import { tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class McsGdsDataService {

  private maxModulesBySeries: Dictionary<string, number> = new Dictionary<string, number>();

  private readonly loadMaxModulesUrl: string = 'cad-export/series/maxmodules';
  private readonly checkCadExportAvailabilityUrl: string = 'cad-export/is-available';

  constructor(private wagoApiClient: WagoApiClient,
  ) {
  }

  public checkCadExportAvailability(projectSeries: string): Observable<boolean> {
    return this.wagoApiClient.get(`${this.checkCadExportAvailabilityUrl}/?series=${projectSeries}`);
  }

  public getMaxModules(series: string): Observable<number> {
    const value = this.maxModulesBySeries.getValue(series);
    if (value) {
      return of(value);
    } else {
      return this.loadMaxModules(series);
    }
  }

  private loadMaxModules(series: string): Observable<number> {
    let httpParams: HttpParams = new HttpParams();
    httpParams = httpParams.append('series', series);
    const requestOptions = {
      params: httpParams
    };

    return this.wagoApiClient.get<number>(this.loadMaxModulesUrl, requestOptions).pipe(
      tap((response) => {
        this.maxModulesBySeries.setValue(series, response);
      }));
  }

  public getSeriesListByType(type: "MCS" | "GDS"): Observable<string[]> {
    return this.wagoApiClient.get<string[]>("cad-export/series/" + type.toLowerCase());
  }
}
